module.exports = __webpack_public_path__ + "static/kategorier-no-4ce5dc06d2fdf4e544736a5a5a870b9c.png";